import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Label,
  Input,
  Button,
  Spinner,
  //   Badge,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
//import paginationFactory from "react-bootstrap-table2-paginator"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import { withRouter } from "react-router-dom"
import Modal from "react-bootstrap/Modal"
import Select from "react-select"
import { useSelector } from "react-redux"
import { connect } from "react-redux"
import moment from "moment"
import * as shooterReportAction from "../../store/c2hvb3RlclJlcG9ydA/actions"
import { isEmpty } from "lodash"
import { ToastContainer } from "react-toastify"
import * as freelancerAuditQcAction from "../../store/ZnJlZWxhbmNlckF1ZGl0UWM/actions"
import ButtonSpinner from "components/ButtonSpinner"
import api from "helpers/Api"
import { toast } from "react-toastify"
import ReactDOM from 'react-dom'
import ShooterTableComponent from "./ShooterTableComponent"

const ShooterQuantity = (props) => {
  const { dispatch, searchBarStyle } = props

  const title = "Shooter Quantity List"

  var date = new Date()
  var firstDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
  const endDate = moment(firstDay).format("YYYY-MM-DD")
  const startingDay = moment().format("YYYY-MM-DD")

  useEffect(() => {
    dispatch(shooterReportAction.loadRecordsMetaData())
    dispatch(
      shooterReportAction.loadRecords({
        page: 1,
        limit: 50,
        eventFromDate: startingDay,
        eventToDate: endDate,
      })
    )
    setEmployeeData({
      fromDate: startingDay,
      toDate: endDate,
    })
    dispatch(freelancerAuditQcAction.loadEmployee())
  }, [])
//date format

const sessionUpdate = useSelector((specificstate) => specificstate.session)
const { user = [] } = sessionUpdate


//date format from localstorage
const authUser = localStorage.getItem("authUser")

const dateLogin = JSON.parse(authUser)

const setDate =
  !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
    ? dateLogin.setting.dateFormate.toUpperCase()
    : !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""
  //Reducer States
  const update = useSelector((specificstate) => specificstate.shooterQuantity)

  const { recordsMetaData = {}, shooter_quantity_report = [],status_data=[]} = update
  const employeeUpdate = useSelector(
    (specificstate) => specificstate.freelancerAuditQc
  )

  const { employee_list = [] } = employeeUpdate
  //Handle Change
  const [resetManager, setResetManager] = useState(false)
  const [company, setCompany] = useState([])
  const [branch, setBranch] = useState([])
  const [department, setDepartment] = useState([])
  const [designation, setDesignation] = useState([])
  const [btnLoader, setBtnLoader] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [employeeData, setEmployeeData] = useState({
    fromDate: "",
    toDate: "",
  })

  //handle Change
  const handleChange = async (e) => {
    setEmployeeData({ ...employeeData, [e.target.name]: e.target.value })
  }

  //dropdown options api
  const branchListOptions =
    !isEmpty(recordsMetaData) &&
    recordsMetaData.branchOptions.filter(
      (branch) => branch.companyId === company.value
    )
  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        options.push(obj)
      })
    return options
  }

  const shooterOptions = createOptions(employeeList)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  const [searchValueList, setSearchValueList] = useState({})
  //const [searchValue,setSearchValue] = useState(false)
  //Pagination states
  const [pageCount, setPageCount] = useState("")
  const [pageChange, setPageChange] = useState(false)
  const handleApply = (e) => {
    e.preventDefault()
    var searchCompany = company && company.value ? company.value : ""
    var searchBranch = branch && branch.value ? branch.value : ""
    var searchShooter =
      shooterList && shooterList.empCode ? shooterList.empCode : ""
    var searchDepartment =
      department && department.value ? department.value : ""
    var searchDesignation =
      designation && designation.value ? designation.value : ""
    var searchFromDate = employeeData.fromDate
      ? moment(employeeData.fromDate).format("YYYY-MM-DD")
      : ""
    var searchToDate = employeeData.toDate
      ? moment(employeeData.toDate).format("YYYY-MM-DD")
      : ""

    var searchFilter = {}
    searchFilter.page = pageChange ? pageCount : 1
    searchFilter.limit = 50
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchDepartment) {
      searchFilter.departmentId = searchDepartment
    }
    if (searchDesignation) {
      searchFilter.designationId = searchDesignation
    }
    if (searchShooter) {
      searchFilter.empCode = searchShooter
    }
    if (searchFromDate) {
      searchFilter.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.eventToDate = searchToDate
    }
    setSearchValueList(searchFilter)
    //setSearchValue(true)
    dispatch(shooterReportAction.loadRecords(searchFilter))
    setDownloadLoading(true)
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
      setDownloadLoading(false)
    }, 2000)
  }
//

  //table data

  let slNo = 0
  const employeeReportTable =
    !isEmpty(shooter_quantity_report) && shooter_quantity_report.data.length > 0
      ? shooter_quantity_report.data.map((data) => {
          slNo = slNo + 1
      
          return {
            sNo: slNo,
            _id: data._id,
            company: data.company,
            companyId: data.companyId,
            shooterCode: data.employeCode,
            shooterName: data.employeName,
            designation: data.designation,
            client: data.client,
            event: data.event,
            outdoorShoot: data.oudoorShoot,
            branch: data.branch,
            status: data.status,
            eventFromDate:searchValueList.eventFromDate?searchValueList.eventFromDate:startingDay,
            eventToDate:searchValueList.eventToDate?searchValueList.eventToDate:endDate
            
          }
        })
      : []
      const [statusData, setStatusData] = useState([])
     
      useEffect(() => {
          setStatusData(status_data)
        
      }, [status_data])
    
  
      const handleClickTab = (tableData,searchValueList) => {
        
          const statusName = tableData.status
          const statusDetails = {
             mode:tableData.mode,
             empCode:tableData.empCode,
           eventFromDate:tableData.eventFromDate,
           eventToDate:tableData.eventToDate
          
          }
       
         
          console.log(searchValueList, "statusDetails")
          const mode = tableData.mode
          
          dispatch(shooterReportAction.loadStatus(statusDetails))
          
          // Use a callback function with setStatusData to ensure statusData is updated
          setTimeout(() => {
              if (statusData) {
                  setStatusData(prevStatusData => {
                      // Access the latest statusData from the callback
                      console.log(prevStatusData, "my imp")
                      const newTab = window.open('', '_blank', 'width=500,height=300')
                      if (newTab) {
                          const container = newTab.document.createElement('div')
                          newTab.document.body.appendChild(container)
                          ReactDOM.render(
                              <ShooterTableComponent
                                  data={prevStatusData}
                                  dispatch={dispatch}
                                  statusPayload={statusDetails}
                                  name={statusName}
                                  mode={mode}
                                  dateFormat = {dateFormat}
                              />,
                              container
                          )
                          newTab.document.title = 'SHOOTER-QUANTITY-LIST'
                      }
                      return prevStatusData // Return the previous statusData
                  })
              }
          }, 2000)
      }
  
  //table columns
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
    },
    {
      dataField: "shooterCode",
      text: "Shooter Code",
      sort: true,
      hidden: false,
      // csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "shooterName",
      text: "Shooter Name",
      sort: true,
      hidden: false,
      // csvExport: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "company",
      text: "Company",
      sort: true,
      hidden: false,
      // csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branch",
      text: "Branch",
      sort: true,
      hidden: false,
      // csvExport: false,
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "designation",
      text: "Designation",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "client",
      text: "Client",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
      formatter: (cellContent, row) => {
     
        const tableData ={
          empCode:row.shooterCode,
          mode:1,
          eventFromDate:row.eventFromDate,
          eventToDate:row.eventToDate,
          status:"Client"
        } 

        return (
            <div onClick={() => handleClickTab(tableData)}
            >
                {cellContent}
            </div>
        )
    },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
    },
    {
      dataField: "event",
      text: "Event",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
      formatter: (cellContent, row) => {
        
        const tableData ={
          empCode:row.shooterCode,
          mode:2,
          eventFromDate:row.eventFromDate,
          eventToDate:row.eventToDate,
          status:"Event"
        } 

        return (
            <div onClick={() => handleClickTab(tableData)}
            >
                {cellContent}
            </div>
        )
    },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
    },
    {
      dataField: "outdoorShoot",
      text: "Outdoor Shoot",
      sort: true,
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
      formatter: (cellContent, row) => {
        
        const tableData ={
          empCode:row.shooterCode,
          mode:3,
          eventFromDate:row.eventFromDate,
          eventToDate:row.eventToDate,
          status:"OutDoor Shoot"
        } 

        return (
            <div onClick={() => handleClickTab(tableData)}
            >
                {cellContent}
            </div>
        )
    },
      style: {
        color: "#e40d8c",
        fontSize: "14px",
        textDecoration: "underline",
      },
    },
  ]

  // Reset functionality

  const [pageLoad, setPageLoad] = useState(false)
  const [shooterList, setShooterList] = useState([])
  const resetFormDetails = () => {
    setCompany([])
    setBranch([])
    setShooterList([])
    setDepartment([])
    setDesignation([])
   // setSearchValue(false)
    setEmployeeData({
      fromDate: startingDay,
      toDate: endDate,
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      shooterReportAction.loadRecords({
        page: pageChange ? pageCount : 1,
        limit: 50,
        fromDate: startingDay,
        toDate: endDate,
      })
    )
  }

  //Columns section
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  //Pagination section start //
  //Search filter
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
 

  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)
    dispatch(
      shooterReportAction.loadRecords({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  //Download functionality

  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchCompany = company && company.value ? company.value : ""
    var searchBranch = branch && branch.value ? branch.value : ""
    var searchShooter =
      shooterList && shooterList.empCode ? shooterList.empCode : ""
    var searchDepartment =
      department && department.value ? department.value : ""
    var searchDesignation =
      designation && designation.value ? designation.value : ""
    var searchFromDate = employeeData.fromDate
      ? moment(employeeData.fromDate).format("YYYY-MM-DD")
      : ""
    var searchToDate = employeeData.toDate
      ? moment(employeeData.toDate).format("YYYY-MM-DD")
      : ""

    var searchFilter = {}
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchDepartment) {
      searchFilter.departmentId = searchDepartment
    }
    if (searchDesignation) {
      searchFilter.designationId = searchDesignation
    }
    if (searchShooter) {
      searchFilter.empCode = searchShooter
    }
    if (searchFromDate) {
      searchFilter.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.eventToDate = searchToDate
    }
    setPageLoad(!pageLoad)
    setDownloadLoading(true)
    api
      .post(`/get_employee_event_details_excel_export`, searchFilter)
      .then((response) => {
      

        const equipmentHrExportExcel = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
              return {
                sNo: index + 1,
                _id: data._id,
                company: data.company,
                companyId: data.companyId,
                shooterCode: data.employeCode,
                shooterName: data.employeName,
                designation: data.designation,
                client: data.client,
                event: data.event,
                outdoorShoot: data.oudoorShoot,
                branch: data.branch,
                status: data.status,
              }
            })
          : []
        setTimeout(() => {
          let headerData = [
            "S.No,Shooter Code, Shooter Name, Company, Branch,Desigantion,Client, Event, Outdoor Shoot",
          ]

          let usersCsv = !isEmpty(equipmentHrExportExcel)
            ? equipmentHrExportExcel.reduce((acc, user) => {
                const {
                  sNo,
                  shooterCode,
                  shooterName,
                  company,
                  branch,
                  designation,
                  client,
                  event,
                  outdoorShoot,
                } = user
                acc.push([
                  sNo,
                  shooterCode,
                  shooterName,
                  company,
                  branch,
                  designation,
                  client,
                  event,
                  outdoorShoot,
                ])

              
                return acc
              }, [])
            : false
        

          const usersList =
            !isEmpty(usersCsv) && usersCsv.length > 0 ? usersCsv : []

          downloadFile({
            data: [...headerData, ...usersList].join("\n"),
            fileName: "ShooterQuantity.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }

  //Remote Paginations
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>

                      <Col md="8">
                        <div
                          style={{
                            marginBottom: "20px",
                            marginTop: "-40px",
                            marginRight: "10px",
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                        <div
                          style={{
                            float: "right",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginBottom: "20px",
                              marginTop: "-41px",
                              marginRight: "10px",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col id="my-component">
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                          // expandRow={expandRow}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )

  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: shooter_quantity_report.length,
    data:
      !isEmpty(shooter_quantity_report) && shooter_quantity_report.length > 0
        ? shooter_quantity_report.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (type, { page, currentIndex, sizePerPage }) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
  
    let result =
      !isEmpty(shooter_quantity_report.data) &&
      shooter_quantity_report.data.length > 0
        ? shooter_quantity_report.data
        : []

    var searchCompany = company && company.value ? company.value : ""
    var searchBranch = branch && branch.value ? branch.value : ""
    var searchShooter =
      shooterList && shooterList.empCode ? shooterList.empCode : ""
    var searchDesignation =
      designation && designation.value ? designation.value : ""
    var searchDepartment =
      department && department.value ? department.value : ""
    var searchFromDate = employeeData.fromDate
      ? moment(employeeData.fromDate).format("YYYY-MM-DD")
      : ""
    var searchToDate = employeeData.toDate
      ? moment(employeeData.toDate).format("YYYY-MM-DD")
      : ""

    var searchFilter = {}
    searchFilter.page = page ? page : 1
    searchFilter.limit = 50
    if (searchCompany) {
      searchFilter.companyId = searchCompany
    }
    if (searchBranch) {
      searchFilter.branchId = searchBranch
    }
    if (searchDepartment) {
      searchFilter.departmentId = searchDepartment
    }
    if (searchDesignation) {
      searchFilter.designationId = searchDesignation
    }
    if (searchShooter) {
      searchFilter.empCode = searchShooter
    }
    if (searchFromDate) {
      searchFilter.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchFilter.eventToDate = searchToDate
    }
    dispatch(shooterReportAction.loadRecords(searchFilter))

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    setTimeout(() => {
      setDownloadLoading(false)
    }, 1400)

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>{title} | Zero Gravity CRM</title>
      </MetaTags>
      <Container fluid>
        <Breadcrumbs title={"Reports"} breadcrumbItem={title} />
        <Row>
          <Col xs={12}>
            <Card>
              <CardBody>
                <form>
                  <Row>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Company</Label>

                      <Select
                        type="text"
                        name="company"
                        value={company}
                        onChange={(e) => setCompany(e)}
                        options={
                          recordsMetaData ? recordsMetaData.companyOptions : []
                        }
                        //           isMulti
                        placeholder="Select Company"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <Label className="employee-label">Branch</Label>
                      <Select
                        type="text"
                        name="branch"
                        //           isMulti
                        value={branch}
                        onChange={(e) => setBranch(e)}
                        options={branchListOptions}
                        placeholder="Select branch"
                        classNamePrefix="select2-selection"
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"}>{"Shooter Name"}</Label>
                      </div>
                      <ReactSearchAutocomplete
                        name="shooterList"
                        key={resetManager}
                        items={shooterOptions}
                        value={shooterList}
                        type="autoComplete"
                        resultStringKeyName="label"
                        showIcon={false}
                        onSelect={(e) => setShooterList(e)}
                        onChange={(e) => setShooterList(e.target.value)}
                        placeholder="Enter Shooter Name"
                        fuseOptions={fuseOptions} // Search on both fields
                        styling={{
                          height: "34px",
                          border: "1px solid #ced4da",
                          borderRadius: "4px",
                          backgroundColor: "white",
                          boxShadow: "none",
                          hoverBackgroundColor: "#E40D8C",
                          color: "black",
                          fontSize: "12px",
                          fontFamily: "Courier",
                          iconColor: "green",
                          clearIconMargin: "3px 8px 0 0",
                          zIndex: 10,
                        }}
                      />
                    </Col>
                    {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Department"}
                        </Label>
                      </div>
                      <Select
                        name="department"
                        value={department}
                        onChange={(e) => setDepartment(e)}
                        // isMulti
                        options={
                          recordsMetaData
                            ? recordsMetaData.departmentOptions
                            : []
                        }
                        placeholder="Select Department"
                        classNamePrefix="select2-selection"
                      />
                    </Col> */}
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className={"form-label"} htmlFor={"Department"}>
                          {"Designation"}
                        </Label>
                      </div>
                      <Select
                        name="designation"
                        value={designation}
                        // isMulti
                        onChange={(e) => setDesignation(e)}
                        options={
                          recordsMetaData
                            ? recordsMetaData.designationOptions
                            : []
                        }
                        placeholder="Select Designation"
                        classNamePrefix="select2-selection"
                      />
                    </Col>
                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label
                          className="form-label"
                          htmlFor={"Event From Date"}
                        >
                          {"Current Month From Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="fromDate"
                        value={employeeData.fromDate}
                        max={employeeData.toDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>

                    <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                      <div className="d-flex justify-content-between">
                        <Label className="form-label" htmlFor={"Event To Date"}>
                          {"Current Month To Date"}
                        </Label>
                      </div>
                      <Input
                        type="date"
                        placeholder="Select Date"
                        name="toDate"
                        value={employeeData.toDate}
                        min={employeeData.fromDate}
                        onChange={(e) => handleChange(e)}
                      />
                    </Col>
                  </Row>
                  <Row>
                    <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                      <div
                        className="filter-buttons"
                        style={{ float: "right" }}
                      >
                        <Button
                          type="button"
                          className="btn btn-danger btn-label simple-form-Reset-btn mx-2"
                          onClick={() => resetFormDetails()}
                        >
                          <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                          Reset
                        </Button>
                        <Button
                          type="submit"
                          onClick={(e) => handleApply(e)}
                          className="btn btn-success btn-label simple-form-applyfilter-btn"
                        >
                          <i className="bx bx-filter-alt label-icon"></i>
                          {btnLoader && btnLoader ? (
                            <ButtonSpinner />
                          ) : (
                            "Apply Filter"
                          )}{" "}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Row className="mt-3">
          <Col md="12" lg="12" xl="12">
            <Card>
              <CardBody>
                <div className="d-flex flex-row" style={{ marginTop: "20px" }}>
                  <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                    <form onSubmit={handleClick} className="d-flex flex-row">
                      <div style={searchBarStyle || null}>
                        <Input
                          type="text"
                          name="searchInput"
                          value={searchInput}
                          onChange={(e) => setSearchInput(e.target.value)}
                          className="form-control"
                          placeholder="Search"
                          style={{ position: "relative" }}
                        />
                        <i
                          className="bx bx-search-alt"
                          style={{
                            position: "absolute",
                            top: "54px",
                            left: "41px",
                            fontSize: "13px",
                          }}
                        />
                      </div>
                      <button
                        className="btn btn-success mx-2"
                        type="submit"
                        style={{
                          background: searchFilter ? "#2ca67a" : "",
                          color: searchFilter ? "#ffffff" : "",
                        }}
                        // onClick={(e) => handleClick()}
                      >
                        <i className="fas fa-search"></i>
                      </button>
                    </form>
                  </div>
                </div>{" "}
                {/* <div className="d-flex flex-row">
                    
                    
                  </div> */}
                <RemotePagination
                  data={employeeReportTable}
                  page={page}
                  sizePerPage={sizePerPage}
                  totalSize={
                    !isEmpty(shooter_quantity_report)
                      ? shooter_quantity_report.totalDataCount
                      : 0
                  }
                  onTableChange={handleTableChange}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        {columnModal && (
          <Modal size="xl" show={columnModal}>
            <Modal.Header
              style={{
                backgroundColor: "white",
                color: "black",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Edit Columns
              <span>
                <i
                  className="fa fa-times quote-close"
                  aria-hidden="true"
                  onClick={() => setColumnModal(false)}
                ></i>
              </span>
            </Modal.Header>
            <Modal.Body>
              <Row>
                <div>
                  <Input
                    type="checkbox"
                    checked={selectedColumns.length === columns.length}
                    onChange={(e) => handleSelectAllChange(e)}
                    style={{ width: "15px", height: "15px" }}
                  />
                  <Label style={{ fontSize: "16px", marginLeft: "10px" }}>
                    Select All
                  </Label>
                </div>
              </Row>
              <Row>
                <Col sm="12" md="6" lg="6" className="ml-4">
                  {oddColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
                <Col sm="12" md="6" lg="6">
                  {evenColumnData.map((column) => (
                    <div key={column.dataField} className="d-flex flex-row">
                      <div className="form-check form-check-inline">
                        <Input
                          type="checkbox"
                          value={column.dataField}
                          checked={selectedColumns.includes(column.dataField)}
                          onChange={(e) => handleCheckboxChange(e)}
                          style={{ width: "15px", height: "15px" }}
                        />
                        <Label
                          style={{
                            fontSize: "16px",
                            marginLeft: "10px",
                          }}
                        >
                          {column.text}
                        </Label>
                      </div>
                    </div>
                  ))}
                </Col>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <p
                className="text-decoration-underline text-info"
                style={{ cursor: "pointer", fontSize: "16px" }}
                onClick={handleRestoreToDefault}
              >
                Restore To Default
              </p>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => {
                  setColumnModal(false)
                  setSelectedColumns(selectColumn)
                }}
              >
                Close
              </Button>
              <Button
                variant="primary"
                className="btn btn-success"
                onClick={() => handleSaveColumns()}
              >
                Submit
              </Button>
            </Modal.Footer>
          </Modal>
        )}
        {downloadLoading ? (
          <Modal
            show={downloadLoading}
            style={{ width: "6.7%", margin: "18% 50%" }}
          >
            <Modal.Body>
              <Spinner
                as="span"
                animation="grow"
                size="lg"
                role="status"
                aria-hidden="true"
                variant="success"
                className="mx-2"
                color="success"
              />
              {/* <span>Loading...</span> */}
            </Modal.Body>
          </Modal>
        ) : (
          ""
        )}
      </Container>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}
ShooterQuantity.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
}
const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShooterQuantity)
)
